import { app } from "modular-openscriptjs";

const h = app("h");

export default function MentionSearchModal(...args) {
	return h.$(
		h.div(
			{ class: "modal-content border-0 bg-light shadow-sm" },
			h.div({ class: "modal-body p-3" }, ...args)
		)
	);
}
